import React, { useEffect } from "react";
import { useState } from "state-pool";
import {
  assets_2,
  assets_3,
  ezlan,
  folder,
  playCircle,
} from "../../../assets/assets";
import httpApiCall from "../../../service/api.service";
import { getStorageValue } from "../../../service/shared.service";
import toastr from "../../elements/toast";
import "./TrainingMaterial.scss";

const toastrService = new toastr(true);
const token = getStorageValue("partnerToken");

const TrainingMaterial = ({ tabactive }: any) => {
  const [plan, setPlan] = useState(1);
  const [trainingData, setTrainingData] = useState([]);
  const [getSelectedValues, setGetSelectedValues] = useState([]);
  const [videoUrl, setVideoUrl] = useState("https://vimeo.com/700333830");
  const [showVideo, setShowVideol] = useState("https://vimeo.com/700333830");

  useEffect(() => {
    getLogos();
  }, []);

  const getLogos = async () => {
    const res = await httpApiCall({
      api: "get_credee_training",
      type: "post",
      body: { access_token: token },
      baseUrltype: true,
    });

    if (res.is_error) {
      toastrService.showError(res.override_text || res.err);
    } else {
      setTrainingData(res.data);
    }
  };

  const getNextTrainingValues = async (val: any) => {
    setPlan(2);
    let body = {
      access_token: token,
      denefits_training_id: val.id,
    };
    const res = await httpApiCall({
      api: "get_credee_training_details",
      type: "post",
      body,
    });

    if (res.is_error) {
      toastrService.showError(res.override_text || res.err);
    } else {
      setGetSelectedValues(res.data);
    }
  };

  const materialTabs = (event: any) => {
    setPlan(1);
  };

  const showData = (val: any) => {
    if (val.type == 2) {
      getVideoPopup(val.training_url);
    } else {
      getTrainingData(val.training_url);
    }
  };
  const getTrainingData = (val: any) => {
    window.open(val, "_blank");
  };

  const getVideoPopup = (item: any) => {
    setVideoUrl(item);
    setTimeout(() => {
      // this.showVideo.show();
    }, 500);
  };

  return (
    <>
      {tabactive == 3 && (
        <div className="mt-md-5">
          <div className="row">
            <div className="col">
              <div className="training-wrapper">
                <>
                  <div className="training-heading">
                    <h5
                      id="1"
                      className={`${plan == 2 ? "active" : ""}`}
                      onClick={(event) => materialTabs(event)}
                    >
                      {plan == 2 && (
                        <span
                          className="back"
                          onClick={(event) => materialTabs(event)}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.3787 3.95312L2.33203 7.99979L6.3787 12.0465"
                              stroke="#292D32"
                              strokeWidth="1.5"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M13.6653 8H2.44531"
                              stroke="#292D32"
                              strokeWidth="1.5"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      )}
                      Training Materials
                    </h5>
                    {plan == 2 && (
                      <span className="mx-1">
                        <svg
                          width="10"
                          height="14"
                          viewBox="0 0 10 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.5 2L1.5 12.5"
                            stroke="#CBD1D9"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    )}
                    {plan == 2 && getSelectedValues.length > 0 && (
                      <h5
                        id="2"
                        className={`${plan == 2 ? "active" : ""}`}
                        onClick={(event) => materialTabs(event)}
                      >
                        {getSelectedValues &&
                          getSelectedValues[0] &&
                          getSelectedValues[0]["training_name"]}
                      </h5>
                    )}
                  </div>
                  {plan == 1 && (
                    <div className="traningmedia pb-4 pb-md-0">
                      <div className="row">
                        <>
                          {/* {console.log(trainingData)} */}
                          {trainingData.map((item: any) => (
                            <div className="col-xl-3 col-6 folder-hover">
                              <div
                                className="folders"
                                onClick={() => getNextTrainingValues(item)}
                              >
                                <img src={folder} alt="folder" />
                              </div>
                              <div className="folders-name">
                                <p>{item.training_name}</p>
                              </div>
                            </div>
                          ))}
                        </>
                      </div>
                    </div>
                  )}

                  {plan == 2 &&
                    getSelectedValues.map((item: any) => (
                      <>
                        <div
                          className="Ezplan cursor"
                          onClick={() => showData(item)}
                        >
                          <div className="Ezplan-wrapper">
                            {item.type == 1 && (
                              <>
                                <img src={ezlan} alt="ezlan" />
                                <div className="Ezplan-text ms-3">
                                  <p className="text1">Flow Diagram</p>
                                  <p className="text2 mb-0">
                                    How {item.training_name} helps businesses
                                  </p>
                                </div>
                              </>
                            )}
                            {item.type == 2 && (
                              <>
                                <img src={assets_2} alt="assets_2" />
                                <div className="Ezplan-text ms-3">
                                  {item.denefits_training_id != 1 &&
                                    item.denefits_training_id != 7 &&
                                    item.denefits_training_id != 8 &&
                                    item.denefits_training_id != 10 && (
                                      <p className="text1">
                                        How {item.training_name} works
                                      </p>
                                    )}
                                  {item.denefits_training_id == 1 && (
                                    <p className="text1">
                                      How does Credee address the voids left
                                      by traditional financing
                                    </p>
                                  )}
                                  {item.denefits_training_id == 7 && (
                                    <p className="text1">
                                      Collect Anytime, Anywhere With Credee
                                      Accounts Receivable AR
                                    </p>
                                  )}
                                  {item.denefits_training_id == 8 && (
                                    <p className="text1">Pay Over Time</p>
                                  )}
                                  {item.denefits_training_id == 10 && (
                                    <p className="text1">
                                      SimpleeFi Payment Plan with Deferred Interest
                                    </p>
                                  )}
                                  <p className="text2 mb-0">2:45</p>
                                </div>
                              </>
                            )}
                            {item.type == 3 && (
                              <>
                                <img src={assets_3} alt="assets_3" />
                                <div className="Ezplan-text ms-3">
                                  {item.id == 3 && (
                                    <p className="text1">
                                      Credee: A New Era of Business Financing
                                    </p>
                                  )}
                                  {item.id != 3 && (
                                    <p className="text1">
                                      Introduction To {item.training_name}
                                    </p>
                                  )}
                                  <p className="text2 mb-0">4 min read</p>
                                </div>
                              </>
                            )}
                          </div>

                          {item.type == 1 && (
                            <div className="Ezplan-view">
                              <a
                                href={item.training_url}
                                target={"_blank"}
                                rel="noreferrer"
                                // onClick={() => getTrainingData(item.training_url)}
                              >
                                View
                              </a>
                            </div>
                          )}
                          {item.type == 2 && (
                            <div className="Ezplan-view">
                              <a
                                href={item.training_url}
                                target={"_blank"}
                                rel="noreferrer"
                                //  onClick={() => getVideoPopup(item.training_url)}
                              >
                                <img alt="playCircle" src={playCircle} />
                              </a>
                            </div>
                          )}
                          {item.type == 3 && (
                            <div className="Ezplan-view">
                              <a
                                href={item.training_url}
                                target={"_blank"}
                                rel="noreferrer"
                                // onClick={() => getTrainingData(item.training_url)}
                              >
                                Read Now
                              </a>
                            </div>
                          )}
                        </div>
                      </>
                    ))}
                </>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TrainingMaterial;
